/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Head from 'next/head';

const Legal = () => {
    return (
        <div className="container">
            <Head>
                <title>Mentions legales</title>
                <meta name="description" content="mentions legales" />
                <meta name="robots" content="noindex follow" />
                <meta name="googlebot" content="noindex follow" />
            </Head>
            <main>
                <div className="main-title">
                    <h1>Mentions légales</h1>
                </div>
                <div style={{ width: '80%', margin: '0 auto', textAlign: 'justify' }}>
                    <p className="preamble">
                        Le fait d'accéder, de naviguer et d'utiliser www.soeezauto.ma (le
                        Site ) signifie que vous acceptez ces conditions légales
                        d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne
                        pas utiliser ce Site.
                    </p>
                    <h2>Conditions légales d'utilisation du Site</h2>
                    <p>
                        Dénomination ou raison sociale :Soc. Adeux SARL, dorenavant
                        SoeezAuto <br /> Adresse du siège social : Marrakech.
                    </p>
                    <p>
                        L’utilisation de ce Site est soumise à la réglementation en
                        vigueur et aux présentes conditions d’utilisation. Vous êtes
                        informés que tout ce que vous visualisez ou lisez sur ce site
                        internet est protégé par le droit de la propriété intellectuelle.
                    </p>
                    <br />
                    <br />
                    <h3>1. Propriété</h3>
                    <p>
                        SoeezAuto a ouvert ce Site pour l'information personnelle de ses
                        utilisateurs. Aucune exploitation commerciale même partielle des
                        données qui y sont présentées ne pourra être effectuée sans
                        l'accord préalable et écrit de SoeezAuto.
                    </p>
                    <p>
                        La présentation et le contenu du présent Site, constituent
                        ensemble, une œuvre protégée par les lois en vigueur sur la
                        propriété intellectuelle (loi n°2-00 relative aux droits d’auteur
                        et droits voisins), dont SoeezAuto est titulaire. Aucune
                        reproduction et/ou représentation, partielle ou intégrale, ne
                        pourra en être faite sans l'accord préalable et écrit de
                        SoeezAuto.
                    </p>
                    <p>
                        La dénomination SoeezAuto, le logo SoeezAuto, ainsi que les
                        slogans, sont, sauf indication particulière, des marques déposées
                        par SoeezAuto. Toute reproduction, utilisation et/ou modification
                        qui en serait faite sans l'accord préalable et écrit de SoeezAuto
                        est susceptible d'en constituer la contrefaçon.
                    </p>
                    <p>
                        La copie à usage privé de ces différents objets de droits est
                        autorisée. Leur reproduction partielle ou intégrale, sans l'accord
                        préalable et écrit de SoeezAuto, est strictement interdite, à
                        l'exception de celle réalisée pour les besoins de la presse.
                        <br /> Les modèles dessinés, photographiés ou filmés peuvent
                        présenter des finitions, des appellations, des équipements en
                        option ou des accessoires en option.
                    </p>
                    <br />
                    <br />
                    <h3>2. Limitation de la responsabilité</h3>
                    <p>
                        Dans les limites maximales permises par la loi, SoeezAuto , et
                        leurs dirigeants, administrateurs, agents, employés, représentants
                        et concédant respectifs (collectivement les « parties SoeezAuto»)
                        ne pourront en aucun cas être tenus responsables de quelque
                        dommage direct, indirect, spécial, accessoire, punitif ou
                        exemplaire que ce soit (y compris, mais sans s'y limiter, la perte
                        de revenus ou de bénéfices, la non-réalisation d'économies
                        anticipées, l'interruption d'activités ou toute autre perte
                        financière ou économique) découlant de l'utilisation ou de
                        l'impossibilité d'utiliser ce Site, et ce, même si une ou
                        plusieurs parties SoeezAuto ont été informées de l'éventualité de
                        tels dommages ou auraient pu raisonnablement prévoir la survenue
                        de tels dommages.
                    </p>
                    <br />
                    <br />
                    <h3>3. Exonérations</h3>
                    <br />

                    <p>
                        (a) Toutes les informations contenues sur ce Site sont fournies
                        uniquement à titre indicatif. Les voitures, modèles, versions et
                        ses données techniques, prix et couts peuvent changer sans
                        préavis. SoeezAuto s'efforce pour garder les données mises à jour
                        et les vérifier avant les publier dans le Site, mais nous donnons
                        aucune garantie de son exactitude.
                    </p>
                    <p>
                        Les couts d'utilisations ( Couts 5 ans), sont fournis à titre
                        indicatif. Chaque propriétaire d'une voiture va avoir des couts
                        différents dependant de plusieurs facteurs, y compris sa façon de
                        conduire, kilométrage parcouru, façon d'entretenir la voiture,
                        entre autres. Vous ne devez pas utiliser, ni vous fier aux
                        informations fournies sur ce site, y compris, mais sans s'y
                        limiter, les calculs des prix, des taxes, des taux de financement
                        et des évaluations de valeur. En cas de divergence ou de conflit
                        entre les informations fournies sur ce Site et les informations
                        qui vous ont été fournies par une succursale ou un revendeur, les
                        informations fournies par une succursale ou un revendeur prévalent
                        et remplacent les informations publiées sur ce Site. SoeezAuto
                        n'est pas responsable de la confiance préjudiciable que vous
                        pourriez accorder à ce Site.
                    </p>
                    <br />
                    <p>
                        (b) Pas de lien juridique - Votre utilisation du Site n'a pas pour
                        but, et ne pourra être interprétée comme telle, de créer un lien
                        juridique quel qu'il soit entre vous et SoeezAuto , ni de modifier
                        un lien juridique existant.
                    </p>
                    <br />
                    <p>
                        (d) Pas de garanties sur le Site - Ce Site et tout autre site Web
                        relié par un lien hypertexte, ainsi que le Contenu et les
                        fonctionnalités de ce Site sont fournis tels quels, sans
                        déclarations, garanties ou conditions quelles qu'elles soient,
                        expresses ou implicites, de la part de SoeezAuto. SoeezAuto ne
                        garantit pas que le fonctionnement de ce Site soit ininterrompu ou
                        exempt d'erreurs, ni que les défauts sur ce Site soient corrigés,
                        ou que ce Site et le serveur grâce auquel il est disponible soient
                        exempts de virus ou d'autres composants nuisibles. SoeezAuto
                        décline toute responsabilité en cas de dommage subi par votre
                        ordinateur ou système informatique découlant de l'accès, de la
                        navigation ou de l'utilisation de ce Site. SoeezAuto ne font
                        aucune déclaration et ne donnent aucune garantie quant à
                        l'exactitude, l'actualité et l'exhaustivité des renseignements
                        contenus sur ce Site. C'est vous et vous seul qui êtes responsable
                        des risques associés à l'utilisation de ce Site, y compris, mais
                        sans s'y limiter, les risques associés à la qualité et à la
                        performance du Site, et à l'exactitude, l'exhaustivité et la
                        fiabilité du contenu de ce Site.
                    </p>
                    <br />
                    <br />
                    <h3>4. Protection des données</h3>
                    <p>
                        Sur soeezauto.ma, nous ne collectons aucune donnée personnelle
                        vous concernant (par ex. nom, adresse, numéro de téléphone ou
                        adresse e-mail), à moins que vous ne choisissiez volontairement de
                        nous les communiquer (par ex. par enregistrement, enquête), que
                        vous nous donniez votre accord ou que la réglementation applicable
                        en matière de protection de données personnelles ne nous y
                        autorise.
                    </p>
                    <p>
                        Seul SoeezAuto est destinataire des informations que vous nous
                        communiquez.
                    </p>
                    <br />
                    <h3>5. Droits d’auteurs et autres droits</h3>
                    <p>
                        Le contenu de ce site Internet est la propriété exclusive de
                        SoeezAuto , ou de tiers et ne doit être ni copié, ni diffusé,
                        modifié ou rendu accessible à des tiers dans des buts commerciaux
                        sans l’accord écrit préalable de SoeezAuto. Les textes,
                        graphiques, bandes sonores, animations, screensavers, séquences
                        vidéos, etc. font en principe l’objet d’une protection du droit
                        d’auteur ou d’autres droits de propriété intellectuelle. Les
                        marques commerciales sont protégées selon le droit des marques.
                    </p>
                    <br />
                    <h3>6. Liens</h3>
                    <p>
                        Les liens hypertextes mis en place dans le cadre du Site en
                        direction d’autres ressources présentes sur le Site ne sauraient
                        engager la responsabilité de SoeezAuto, notamment sa
                        responsabilité, au regard de l’ensemble du contenu des autres
                        ressources directes ou indirectes. SoeezAuto décline toute
                        responsabilité s’agissant des liens hypertextes qui peuvent
                        apparaître sur le Site et interdit à toute personne de mettre en
                        place un tel lien sans son autorisation préalable.
                    </p>
                    <br />
                    <h3>7. Cookies</h3>
                    <p>
                        Lorsque vous utilisez le Site, des « cookies » sont stockés sur
                        votre ordinateur. De tels cookies enregistrent des informations
                        sur la navigation de votre ordinateur sur le Site (pages choisies,
                        jour, heure et durée de l’utilisation, etc.). Nous pouvons ensuite
                        lire ces informations puis adapter le Site à vos besoins
                        personnels et optimiser les durées de chargement. Cela nous
                        permettra de mieux connaître vos centres d’intérêts. Vous avez la
                        possibilité de contrôler vous-mêmes l’acceptation de ces cookies
                        et le cas échéant de les refuser. Pour cela, il vous suffit de
                        configurer votre navigateur.
                    </p>
                    <br />

                    <p>
                        Les fournisseurs tiers, y compris Google, utilisent des cookies
                        pour diffuser des annonces en fonction des visites antérieures des
                        internautes sur soeezauto.ma. Grâce au cookie DoubleClick, Google
                        et ses partenaires adaptent les annonces diffusées auprès de nos
                        visiteurs en fonction de leur navigation sur soeezauto.ma et/ou
                        d'autres sites Web. Les internautes peuvent désactiver le cookie
                        DoubleClick utilisé pour la diffusion d'annonces par centres
                        d'intérêt via les Paramètres Google Solutions publicitaires.
                    </p>
                    <br />

                    <h3>8. Loi applicable et compétence</h3>
                    <p>
                        Les présentes conditions sont soumises à la loi marocaine.
                        L'attribution de compétence en cas de litige, et à défaut d'accord
                        amiable entre les parties, est donnée au Tribunal de Commerce de
                        Marrakech.
                    </p>
                </div>
            </main>
        </div>
    );
};

export default Legal;
